import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';

const exitModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 560,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '22px 20px 14px',
};

type ExitDialogProps = {
  open: boolean;
  onClose: () => void;
  mode: 'confirm';
  title?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  width?: number | string;
  onCancel: () => void;
  onConfirm: () => void;
  isBusy?: boolean;
};

export default function ExitDialog(props: ExitDialogProps) {
  const title = props.title ?? 'Are you sure you want to exit? You may lose data!';

  return (
    <Modal open={props.open} onClose={props.onClose} className="custom-modal">
      <Box sx={exitModalStyle} style={props.width ? { width: props.width } : undefined}>
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
        <Box sx={{ height: 18 }} />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginBottom: 0 }}>
          <>
            <Button variant="contained" className="modal-no-btn" onClick={props.onCancel} disabled={props.isBusy}>
              {props.cancelLabel ?? 'Cancel'}
            </Button>
            <Button variant="contained" className="modal-yes-btn" onClick={props.onConfirm} disabled={props.isBusy}>
              {props.isBusy ? (
                <CircularProgress size={18} thickness={5} color="inherit" />
              ) : (
                (props.confirmLabel ?? 'Yes')
              )}
            </Button>
          </>
        </Box>
      </Box>
    </Modal>
  );
}
